import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import isNull from 'lodash-es/isNull';
import moment from 'moment';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

import { CalendarCustomHeaderComponent } from '../../widgets/custom-calendar-header';
import { EditableComponent } from '../editable.types';

@Component({
  templateUrl: './date-editable.component.html',
  styles: [
    `
      .error {
        border: 1px solid red;
      }
    `,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'L',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'L',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class DateEditableComponent extends EditableComponent implements OnInit {
  @ViewChild('dtPicker') dtPicker: MatDatepicker<moment.Moment>;

  value;
  editing = false;
  emptyCellOverlay: boolean;
  error = false;
  customHeader = CalendarCustomHeaderComponent;

  private originalValue: string;

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.getValue();
    this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
    this.originalValue = this.value;
    if (this.fieldDef?.meta?.readonly) this.readonly = this.fieldDef.meta.readonly;

    this.formatDate();

    if (this.editMode) {
      this.editing = this.editMode;
      setTimeout(() => this.dtPicker?.open(), 100);
    }
  }

  edit(): void {
    if (!this.editing && !this.isDisabled) {
      this.editing = true;
      setTimeout(() => this.dtPicker?.open(), 100);
    }
  }

  hideEdit(): void {
    this.editing = false;
    this.editMode = false;
  }

  formatDate(): void {
    if (this.value && this.isNestedField) {
      this.value = this.value.map((item) => {
        return {
          ...item,
          label: item.label && moment(item.label).isValid() ? moment(item.label).format('YYYY-MM-DD') : '',
        };
      });
    } else if (this.value) {
      this.value = moment(this.value).isValid() ? moment(this.value).format('YYYY-MM-DD') : null;
    }
  }

  onBlur(): void {
    this.processUpdate();
  }

  processUpdate(): void {
    this.hideEdit();
    this.save();
    this.onEndEditing.emit();
  }

  save(): void {
    if (this.originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this.originalValue = this.value;
  }

  onDateChange(event: MatDatepickerInputEvent<Date>): void {
    if (!this.readonly) {
      if (!event.value) {
        this.value = null;
        this.processUpdate();
        return;
      }

      const momentDate = moment(event.value);
      this.value = momentDate.format('YYYY-MM-DD');
      this.emptyCellOverlay = this.showEmptyHolder && isNull(this.value);
      this.processUpdate();
    }
  }
}
